import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthenticationProvider } from '../../context/AuthenticationContext';
import { ProjectProvider } from '../../project-details/context/ProjectContext';
import SaveBearingDropdown from './SaveBearingDropdown';
import ToastNotification from '../../components/toast/ToastNotification';

const $saveBearingDropdowns: NodeListOf<HTMLElement> | null = document.querySelectorAll('[id=save-bearing-to-project]');
const $displaySaveBearingDropdown = window._timken?.displaySaveBearingDropdown;

if ($saveBearingDropdowns && $displaySaveBearingDropdown) {
	$saveBearingDropdowns.forEach(($saveBearingDropdown) => {
		const materialNumber = $saveBearingDropdown.dataset.materialNumber ?? '';
		const marketPlaceDescription = $saveBearingDropdown.dataset.marketplaceDescription ?? '';
		const bore = $saveBearingDropdown.dataset.bore ?? '';
		const outerDiameter = $saveBearingDropdown.dataset.outerDiameter ?? '';
		const bearingWidth = $saveBearingDropdown.dataset.bearingWidth ?? '';
		const bearingTypeDescription = $saveBearingDropdown.dataset.bearingDescription ?? '';
		const bearingTypeImageUrl = $saveBearingDropdown.dataset.thumbnail ?? '';
		const buttonStyle = $saveBearingDropdown.dataset.buttonStyle ?? 'min';

		const $root = ReactDOM.createRoot($saveBearingDropdown as HTMLElement);

		$root.render(
			<React.StrictMode>
				<AuthenticationProvider>
					<ProjectProvider>
						<SaveBearingDropdown {...{
							materialNumber,
							marketPlaceDescription,
							bore,
							outerDiameter,
							bearingWidth,
							bearingTypeDescription,
							bearingTypeImageUrl,
							buttonStyle,
						}} />

						<ToastNotification/>
					</ProjectProvider>
				</AuthenticationProvider>
			</React.StrictMode>
		);
	});
}
